"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackDataEpoqUpdateCart = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
const getDataEpoqObject_1 = require("./getDataEpoqObject");
function trackDataEpoqUpdateCart(cart, tenant) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        DataEpoqUpdateCart: (0, getDataEpoqObject_1.getDataEpoqObject)(cart, tenant),
    });
}
exports.trackDataEpoqUpdateCart = trackDataEpoqUpdateCart;
//# sourceMappingURL=trackDataEpoqUpdateCart.js.map